import script from "./workload-view-summary-error-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-summary-error-item.vue?vue&type=script&setup=true&lang=ts"

import "./workload-view-summary-error-item.vue?vue&type=style&index=0&id=aacc8c84&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aacc8c84"]])

export default __exports__